import { API } from 'aws-amplify';

export const engagementInsightandFeature = (body) =>
{
	return new Promise((resolve, reject) =>
	{
		API.post('analyticsApi', '/engagementinsightandfeature', { body })
			.then((res) =>
			{
				resolve(res);
			})
			.catch((err) =>
			{
				reject(err);
			});
	});
};
